// Storage expiry durations in milliseconds
export const EXPIRY = {
  ROOM_TEMP_MS: 4 * 60 * 60 * 1000,
  FRIDGE_MS: 4 * 24 * 60 * 60 * 1000,
  FREEZER_MS: 6 * 30 * 24 * 60 * 60 * 1000,
  DEEP_FREEZER_MS: 12 * 30 * 24 * 60 * 60 * 1000,
} as const;

// Default settings
export const DEFAULTS = {
  FEED_ALERT_THRESHOLD_MS: 3 * 60 * 60 * 1000,
  PUMP_REMINDER_INTERVAL_MS: 3 * 60 * 60 * 1000,
  TIMER_PERSIST_INTERVAL_MS: 5000,
} as const;

// Diaper reference ranges (optional, can be hidden)
export const DIAPER_REFERENCE = {
  NEWBORN_WET_MIN: 6,
  NEWBORN_DIRTY_MIN: 3,
} as const;
